import { useEffect } from "react";
import { useLocation } from "react-router";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        let modalDiv = document.getElementsByClassName('modal-backdrop');
        let body = document.getElementsByTagName('body');
        if (modalDiv.length > 0) {
            modalDiv.item(0).remove();
        }
        if (body.length > 0) {
            body.item(0).setAttribute('style', '');
            body.item(0).setAttribute('class', '');
        }
    }, [pathname]);

    return null;
}